import axios from "axios";

class Config {
  private _serverUrl = "";
  private _appName = "";

  set AppName(appName: string) {
    this._appName = appName;
  }

  get AppName() {
    return this._appName;
  }

  set ServerUrl(serverUrl: string) {
    this._serverUrl = serverUrl;
  }

  get ServerUrl() {
    return this._serverUrl;
  }
}

class AppConfig {
  private static config: Config;

  static get Config() {
    return AppConfig.config;
  }

  static readConfig() {
    const promise = new Promise(function (resolve, reject) {
      try {
        if (AppConfig.config == null) {
          const confAxios = axios.create();
          confAxios
            .get("/config.json")
            .then(function (response) {
              AppConfig.config = new Config();
              AppConfig.config.AppName = response.data.appName;
              AppConfig.config.ServerUrl = response.data.serverUrl;
              resolve("succeed");
            })
            .catch(function (error) {
              reject(error);
            });
        } else {
          resolve("succeed");
        }
      } catch (error) {
        reject(error);
      }
    });
    return promise;
  }
}

export { Config, AppConfig };
